var _path, _circle, _circle2, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatienticonadultMyositis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.5C26.1039 19.8576 19.8211 25.0999 17.2281 27.0897C16.5682 27.5961 15.6727 27.6015 15.0068 27.1032C12.3613 25.1236 5.89704 19.8674 5.5 15.5C5.5 9.82693 9.83422 2 16.1223 2C22.4103 2 26.5 9.82693 26.5 15.5Z",
    fill: "#CDF2FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11,
    fill: "#CDF2FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 9,
    fill: "#CDF2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1586 7.20994C14.1586 7.20994 14.5748 6.50256 15.8388 6.50256C17.1027 6.50256 17.5894 7.19986 17.5894 7.19986C17.5894 7.19986 17.8431 8.23603 17.6143 8.44865C17.3636 8.68187 17.1931 7.97718 15.8689 7.95712C14.5446 7.93706 13.9629 8.5791 13.9629 8.5791L14.1586 7.20994Z",
    fill: "#226985"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2401 7.10266C14.2401 7.10266 13.4375 7.77153 16.3801 11.1688C19.3228 14.5663 19.7508 15.8504 19.7508 15.8504L18.654 18.8732C18.654 18.8732 16.0324 14.593 14.6414 12.6402C13.2502 10.6874 12.7863 9.048 14.2401 7.10266Z",
    fill: "#226985"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5107 7.10266C17.5107 7.10266 18.3132 7.77153 15.3706 11.1688C12.428 14.5663 12 15.8504 12 15.8504L13.0968 18.8732C13.0968 18.8732 15.7183 14.593 17.1093 12.6402C18.5005 10.6874 19.1383 9.02805 17.5107 7.10266Z",
    fill: "#3388A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatienticonadultMyositis);
export default __webpack_public_path__ + "static/media/patienticonadult-myositis.aec9f433ff181dd3cbb78a44382bd153.svg";
export { ForwardRef as ReactComponent };